// import React, { useState } from 'react'
// import Logo from '../Assets/Assests/Logos/Final - logo ---Photoroom 3.png'
// import { FaBell, FaSearch, FaSignOutAlt } from 'react-icons/fa'
// import { useNavigate } from 'react-router-dom'
// import AiLogo from '../Assets/Assests/FinalLogo.png'

// export default function Navbar() {
//   const navigate = useNavigate()
//   const [isOpen, setIsOpen] = useState(false)

//   const handleToggle = () => {
//     setIsOpen(!isOpen)
//   }

//   const handleLogOut = () => {
//     localStorage.clear()
//     navigate('/')
//   }

//   return (
//     <nav
//       className='navbar navbar-expand-lg'
//       style={{
//         backgroundColor: 'white',
//         boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.25)',
//         height: '80px', // Adjust height as needed
//         padding: '5px 15px', // Reduce top-bottom padding
//       }}
//     >
//       <div
//         className='container-fluid'

//       >
//         <a className='navbar-brand d-flex align-items-center text-white'>
//           <img
//             src={AiLogo}
//             alt='Museum Logo'
//             className='me-2'
//             width={210}
//             height={80}
//             style={{ marginRight: '20px', marginLeft: '20px' }}
//           />
//           {/* <span className='fw-bold' style={{ color: 'black' }}>
//             TESLA BIRD
//           </span> */}
//         </a>

//         <button className='navbar-toggler' type='button' onClick={handleToggle}>
//           <span className='navbar-toggler-icon'></span>
//         </button>

//         <div
//           className={`collapse navbar-collapse justify-content-end ${
//             isOpen ? 'show' : ''
//           }`}
//           id='navbarNav'
//         >
//           <ul className='navbar-nav align-items-center'>
//             <li className='nav-item'>
//               <a className='nav-link active' href='/home'>
//                 Home
//               </a>
//             </li>
//             <li className='nav-item'>
//               <a className='nav-link  active' href='/dashboard'>
//                 Learning
//               </a>
//             </li>
//             <li className='nav-item'>
//               <a className='nav-link ' href='/profile'>
//                 Profile
//               </a>
//             </li>
//             <li className='nav-item mx-3'></li>
//             <li className='nav-item'>
//               <a
//                 className='nav-link  fw-bold d-flex align-items-center'
//                 onClick={handleLogOut}
//                 style={{ cursor: 'pointer' }}
//               >
//                 <FaSignOutAlt className='me-2' /> Logout
//               </a>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </nav>
//   )
// }

// import { useState, useEffect } from 'react'
// import { useNavigate } from 'react-router-dom'
// import axios from 'axios'
// import { FaSignOutAlt } from 'react-icons/fa'
// import AiLogo from '../Assets/Assests/FinalLogo.png'

// export default function Navbar() {
//   const navigate = useNavigate()
//   const [isOpen, setIsOpen] = useState(false)
//   const [userDetails, setUserDetails] = useState(null)

//   const handleToggle = () => {
//     setIsOpen(!isOpen)
//   }

//   const handleLogOut = () => {
//     localStorage.clear()
//     navigate('/')
//   }

//   useEffect(() => {
//     const fetchUserDetails = async () => {
//       try {
//         const response = await axios.get(
//           'https://aimuseumbackend.teslabird.com/auth/user_details/',
//           {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem('access')}`,
//             },
//           }
//         )

//         // Correctly access user_data from the response
//         const userData = response.data

//         if (userData) {
//           // Set user details correctly
//           setUserDetails({
//             name: `${userData.first_name} ${userData.last_name}`.trim(),
//           })
//         } else {
//           console.error('User data not found in response')
//         }
//       } catch (error) {
//         console.error(
//           'Error fetching user details:',
//           error.response?.data || error.message
//         )
//       }
//     }

//     fetchUserDetails()
//   }, [])

//   return (
//     <nav
//       className='navbar navbar-expand-lg'
//       style={{
//         backgroundColor: 'white',
//         boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.25)',
//         height: '80px',
//         padding: '5px 15px',
//       }}
//     >
//       <div className='container-fluid'>
//         <a className='navbar-brand d-flex align-items-center'>
//           <img
//             src={AiLogo}
//             alt='Logo'
//             className='me-2'
//             width={180}
//             height={70}
//             style={{ marginRight: '15px' }}
//           />
//         </a>

//         {/* Toggler Button for Mobile */}
//         <button
//           className='navbar-toggler'
//           type='button'
//           onClick={handleToggle}
//           style={{ border: 'none', background: 'transparent' }}
//         >
//           <span className='navbar-toggler-icon'></span>
//         </button>

//         {/* Collapsible Navbar */}
//         <div
//           className={`collapse navbar-collapse justify-content-end ${
//             isOpen ? 'show' : ''
//           }`}
//           style={{
//             backgroundColor: isOpen
//               ? 'rgba(255, 255, 255, 0.95)'
//               : 'transparent',
//             position: isOpen ? 'absolute' : 'static',
//             top: '80px',
//             right: '0',
//             width: isOpen ? '100%' : 'auto',
//             zIndex: '1000',
//             borderRadius: '10px',
//             padding: isOpen ? '15px' : '0',
//             boxShadow: isOpen ? '0px 4px 10px rgba(0, 0, 0, 0.25)' : 'none',
//           }}
//         >
//           <ul className='navbar-nav align-items-center text-center'>
//             <li className='nav-item'>
//               <a
//                 className='nav-link active'
//                 href='/home'
//                 style={{ fontSize: '16px' }}
//               >
//                 Home
//               </a>
//             </li>
//             {/* <li className='nav-item'>
//               <a
//                 className='nav-link active'
//                 href='/dashboard'
//                 style={{ fontSize: '16px' }}
//               >
//                 Learning
//               </a>
//             </li> */}
//             <li className='nav-item'>
//               <a
//                 className='nav-link'
//                 href='/profile'
//                 style={{ fontSize: '16px', marginRight: '20px' }}
//               >
//                 Profile
//               </a>
//             </li>

//             {/* Show Username */}
//             {userDetails && (
//               <>
//                 <li className='d-none d-lg-block border-start border-secondary h-100' />
//                 <li>
//                   <div
//                     className='px-3 py-2 rounded-pill text-white fw-medium'
//                     style={{ backgroundColor: '#B02010' }}
//                   >
//                     {userDetails.name}
//                   </div>
//                 </li>
//                 <li>
//                   <button
//                     onClick={handleLogOut}
//                     className='d-flex align-items-center gap-2 text-secondary fw-medium btn btn-link'
//                   >
//                     <FaSignOutAlt />
//                     <span>Logout</span>
//                   </button>
//                 </li>
//               </>
//             )}
//           </ul>
//         </div>
//       </div>
//     </nav>
//   )
// }

import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { FaSignOutAlt, FaHome, FaThLarge } from 'react-icons/fa'
import AiLogo from '../Assets/Assests/Logos/Tesla bird logo.png'

export default function Navbar() {
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const [userDetails, setUserDetails] = useState(null)

  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  const handleLogOut = () => {
    localStorage.clear()
    navigate('/')
  }

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(
          'https://aimuseumbackend.teslabird.com/auth/user_details/',
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('access')}`,
            },
          }
        )

        // Correctly access user_data from the response
        const userData = response.data

        if (userData) {
          // Set user details correctly
          setUserDetails({
            name: `${userData.first_name} ${userData.last_name}`.trim(),
          })
        } else {
          console.error('User data not found in response')
        }
      } catch (error) {
        console.error(
          'Error fetching user details:',
          error.response?.data || error.message
        )
      }
    }

    fetchUserDetails()
  }, [])

  return (
    <nav
      className='navbar navbar-expand-lg'
      style={{
        backgroundColor: 'white',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        height: '70px',
        padding: '0 20px',
      }}
    >
      <div className='container-fluid'>
        <a className='navbar-brand d-flex align-items-center'>
          <img
            src={AiLogo || '/placeholder.svg'}
            alt='Logo'
            className='me-2'
            width={80}
            height={60}
          />
        </a>

        {/* Toggler Button for Mobile */}
        <button
          className='navbar-toggler'
          type='button'
          onClick={handleToggle}
          style={{ border: 'none', background: 'transparent' }}
        >
          <span className='navbar-toggler-icon'></span>
        </button>

        {/* Collapsible Navbar */}
        <div
          className={`collapse navbar-collapse justify-content-end ${
            isOpen ? 'show' : ''
          }`}
          style={{
            backgroundColor: isOpen
              ? 'rgba(255, 255, 255, 0.98)'
              : 'transparent',
            position: isOpen ? 'absolute' : 'static',
            top: '70px',
            right: '0',
            width: isOpen ? '100%' : 'auto',
            zIndex: '1000',
            padding: isOpen ? '15px' : '0',
            boxShadow: isOpen ? '0px 4px 10px rgba(0, 0, 0, 0.1)' : 'none',
          }}
        >
          <ul className='navbar-nav align-items-center'>
            {/* <li className='nav-item me-3'>
              <a
                className='nav-link d-flex align-items-center'
                href='/modules'
                style={{ fontSize: '15px', fontWeight: '500' }}
              >
                <FaThLarge className='me-1' /> Modules
              </a>
            </li> */}
            <li className='nav-item me-3'>
              <a
                className='nav-link d-flex align-items-center'
                href='/home'
                style={{ fontSize: '15px', fontWeight: '500' }}
              >
                <FaHome
                  style={{
                    color: '#1669C9',
                  }}
                  className='me-1'
                />
                Home
              </a>
            </li>
            <li className='nav-item me-3'>
              <a
                className='nav-link d-flex align-items-center'
                href='/'
                onClick={handleLogOut}
                style={{ fontSize: '15px', fontWeight: '500' }}
              >
                <FaSignOutAlt
                  style={{
                    color: '#1669C9',
                  }}
                  className='me-1'
                />{' '}
                Logout
              </a>
            </li>

            {/* User Avatar */}
            {userDetails && (
              <li className='nav-item ms-2'>
                <div
                  className='rounded-circle d-flex align-items-center justify-content-center'
                  style={{
                    width: '40px',
                    height: '40px',
                    backgroundColor: '#007bff',
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '16px',
                  }}
                >
                  {userDetails.name.charAt(0)}
                </div>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  )
}
